import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import withAuth from "../helpers/withAuth";
import Layout from "../components/Layout";
import IssueOverview from "../screens/IssueOverview";
import { IssueType } from "@store/issue/types";
import { isTechnicalManager, isSupervisor } from "../helpers";
import { selectCurrentRole } from "@store/user/userSelectors";
import useAppSelector from "@hooks/useAppSelector";

const TDOverviewContainer: FC = () => {
  const navigate = useNavigate();
  const role = useAppSelector(selectCurrentRole);

  useEffect(() => {
    if (role && !(isTechnicalManager(role) || isSupervisor(role)))
      navigate("/");
  }, [role, navigate]);

  return (
    <Layout active="td-overview">
      <IssueOverview type={IssueType.TECHNICAL} />
    </Layout>
  );
};

export default withAuth(TDOverviewContainer);
